var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"pt-0"},[_c('v-card',{staticClass:"px-3 py-0",style:('background-color:transparent !important; display: flex; justify-content: center;' +
      (_vm.titleBox ? 'cursor: pointer;' : ' ') +
      'border:' +
      (_vm.titleBox ? '1' : '0') +
      'px solid; border-color:' +
      _vm.boxBorderColor +
      ' ;border-radius: 0px;'),attrs:{"outlined":"","max-width":90,"color":_vm.boxColor}},[_c('span',{class:_vm.titleClass,style:(_vm.hoverStyle),on:{"mouseover":function($event){return _vm.mouseOver()},"mouseleave":function($event){return _vm.mouseOver()}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }